module.exports = __webpack_public_path__ + "ppt2.9a09171dc03230bc95e4.svg";


//////////////////
// WEBPACK FOOTER
// /Users/apple/Documents/object/chinaicac-portal/src/assets/icon/ppt2.svg
// module id = ../../../../../src/assets/icon/ppt2.svg
// module chunks = main